import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('paperwork', 'appointment-session');

export const actions = createActions(consts);

export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'paperwork',
  type: 'post',
  slug: [
    'appointments',
    {
      type: 'payload',
      selector: ['appointmentUUID'],
    },
    'sessions',
  ],
});

export default createReqReducer(consts, true);



// WEBPACK FOOTER //
// ./src/redux/paperwork/requests/paperwork-appointment-session.js